import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n";

export default function ForbiddenState() {
  const navigate = useNavigate();
  const { t } = useI18n();

  return (
    <div className="max-w-2xl mx-auto p-6 md:p-10" data-testid="forbidden-state">
      <div className="rounded-lg border border-[var(--subtle)] bg-white p-8 text-center shadow-sm">
        <ShieldAlert className="mx-auto h-10 w-10 text-[var(--accent)]" aria-hidden="true" />
        <h1 className="mt-4 font-display text-2xl font-bold text-[var(--text-primary)]">
          {t("forbidden.title")}
        </h1>
        <p className="mt-2 text-[var(--text-secondary)]">{t("forbidden.message")}</p>
        <Button
          type="button"
          variant="outline"
          className="mt-6"
          onClick={() => navigate(-1)}
          data-testid="forbidden-back"
        >
          <ArrowLeft className="me-2 h-4 w-4" aria-hidden="true" />
          {t("forbidden.back")}
        </Button>
      </div>
    </div>
  );
}
